import React from 'react';

import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';

import * as ST from './styled';

export interface ILesion {
    id: number | string,
    image: string,
    image_webp: string,
    title: string,
    alt: string,
}

interface IProps {
    items: ILesion[],
    isDesktop: boolean,
    isLaptop: boolean,
    className?: string,
}

const Lesions: React.FC<IProps> = ({ items = [], className = '', isDesktop, isLaptop }): JSX.Element => {
    return (<ST.Wrapper className={className}>
        <AdaptiveNukaCarousel
            desktopSlideWidth={
                isLaptop
                    ? '327'
                        : isDesktop
                        ? '288'
                    : '358'
            }
            withoutArrows
            cellSpacing={24}
            slidesToScroll={'auto'}
            heightMode='max'
            customDotsStyles={ST.customDotsStyles}
            data-test='lesions-carousel'
        >
            {
                items.map((item) => {
                    return (
                        <ST.LesionItem data-test='lesion-item' key={item.id}>
                            <ST.Picture>
                                <source srcSet={item.image_webp} type='image/webp' />
                                <ST.Image
                                    src={item.image}
                                    alt={item.alt}
                                    data-test='lesion-item-image'
                                    width={280}
                                    height={171}
                                />
                            </ST.Picture>
                            <ST.Title data-test='lesion-item-title'>{item.title}</ST.Title>
                        </ST.LesionItem>
                    );
                })
            }
        </AdaptiveNukaCarousel>
    </ST.Wrapper>);
};

export default Lesions;
